const initialState = {
  courses: [],
  params: {},
  totalCourses: 0,
  courseDetail: {},
  transactionCourseUser: {},
  transactionCourseUserAddress: {},
};

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_COURSES":
      return {
        ...state,
        courses: action.data.courses,
        params: action.params,
        totalCourses: action.data.totalCourses,
      };
    case "GET_COURSE_DETAIL":
      return {
        ...state,
        courseDetail: action.data.courseDetail,
        transactionCourseUser: action.data.transactionCourseUser,
        transactionCourseUserAddress: action.data.transactionCourseUserAddress,
      };
    case "SAVE_COURSE_REGISTRATION":
      return {
        ...state,
        courseDetail: action.data.courseDetail,
        transactionCourseUser: action.data.transactionCourseUser,
        transactionCourseUserAddress: action.data.transactionCourseUserAddress,
      };
    default:
      return state;
  }
};

export default courseReducer;
